const mapValues = (data, execute) =>
  Object.keys(data).reduce((acc, key) => {
    acc[key] = execute(data[key], key, data);
    return acc;
  }, {});

export { mapValues };
